import React from "react";

export default function WeatherIcon({ data }) {
  if (!data) {
    return null;
  }

  return (
    <div className="WeatherIcon">
      <img src={data.icon} alt="weather icon" className="float-left" />
    </div>
  );
}
